import React, { Component } from 'react'

export default class NotFound extends Component {
  render() {
    return (
      <div style={{textAlign: 'center', fontSize: 'large'}}>404 NotFound</div>
    )
  }
}
